import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { Button } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

import TopCard from 'common/containers/TopCard';

import CustomTargetDialog from 'routes/CustomTargets/components/CustomTargetDialog';
import { fetchCustomTargets } from 'store/actions/campaigns';

const CustomTargetsTopCard = () => {
  const dispatch = useDispatch();
  const { organizationUuid } = useParams();

  const [isCustomTargetModalOpen, setIsCustomTargetModalOpen] = useState(false);

  const topCardData = useCallback(
    () => ({
      backButtonLink: `/${organizationUuid}/campaigns`,
      restActions: (
        <Button
          color="primary"
          disableElevation
          onClick={() => setIsCustomTargetModalOpen(true)}
          startIcon={<AddIcon />}
          variant="contained"
        >
          Add Target
        </Button>
      ),
      title: 'Custom Targets',
    }),
    [organizationUuid]
  );

  return (
    <>
      <TopCard {...topCardData()} />
      <CustomTargetDialog
        isDialogOpen={isCustomTargetModalOpen}
        handleDialogClose={() => setIsCustomTargetModalOpen(false)}
        onSuccess={() => dispatch(fetchCustomTargets({ organization: organizationUuid }))}
      />
    </>
  );
};

export default CustomTargetsTopCard;
